<template>
  <hit-panel :title="title" closable>
    <template #body>
      <div>
        <iframe class="w-full" :src="srcWithParams"></iframe>
      </div>
    </template>
  </hit-panel>
</template>

<script>
import {HitPanel} from '../panel';

export default {
  name: 'HitTopIframe',
  components: {
    HitPanel,
  },

  props: {
    /**
     * String displayed as panel title
     */
    title: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Url to the html file we want to load in the iframe
     */
    src: {
      type: String,
      required: true,
    },
  },

  computed: {
    srcWithParams() {
      return `${this.src}&route=${this.$route.fullPath}&customButton=true`;
    },
  },
};
</script>
